import React from "react";
import "../../styles/css/InfoBox.css";

Date.prototype.hhmmddmm = function () {
  var mm = this.getMonth() + 1; // getMonth() is zero-based
  var dd = this.getDate();
  var hour = this.getHours();
  var min = this.getMinutes();
  return (
    (hour > 9 ? "" : "0") +
    hour +
    ":" +
    (min > 9 ? "" : "0") +
    min +
    " (" +
    (dd > 9 ? "" : "0") +
    dd +
    "/" +
    (mm > 9 ? "" : "0") +
    mm +
    ")"
  );
};

export default function InfoBox(props) {
  const lastUpdateDescription = (alert) => {
    if (alert.locationDate != undefined) {
      var diff = new Date().getTime() - alert.locationDate;
      var minutes = Math.floor(diff / 1000 / 60);
      if (minutes < 60)
        return "Ubicación actualizada hace " + minutes + " minutos";
      else {
        var hours = Math.floor(minutes / 60);
        return "Ubicación actualizada hace " + hours + " horas";
      }
    }
  };

  const location = (alert) => {
    if (alert.location !== undefined)
      return (
        "Latitud: " +
        alert.location.latitude +
        " Longitud: " +
        alert.location.longitude
      );
    return "UBICACIÓN DESCONOCIDA";
  };

  const creationDate = (alert) => {
    if (alert.creationTime !== undefined) {
      var diff = new Date().getTime() - alert.creationTime;
      var minutes = Math.floor(diff / 1000 / 60);
      if (minutes < 60) return "Alerta creada hace " + minutes + " minutos";
      else {
        var hours = Math.floor(minutes / 60);
        return "Alerta creada hace " + hours + " horas";
      }
    }
  };

  const state = (alert) => {
    let states = ["PENDIENTE DE RECEPCIÓN", "CONFIRMADO", "POLICIA EN CAMINO"];
    return "Estado: " + states[alert.state];
  };

  return (
    <div className="infoBox">
      <h1>
        {props.alert.name} {props.alert.lastName}
      </h1>
      <h2>{lastUpdateDescription(props.alert)}</h2>
      <hr />
      <p>Teléfono: {props.alert.phoneNumber} </p>
      <p>{creationDate(props.alert)}</p>
      <p>{location(props.alert)}</p>
      {props.alert.violent.name !== undefined &&
      props.alert.violent.lastName !== undefined ? (
        <p>
          Denunciado: {props.alert.violent.name} {props.alert.violent.lastName}{" "}
        </p>
      ) : null}
      {props.alert.violent.phoneNumber !== undefined ? (
        <p>Teléfono denunciado: {props.alert.violent.phoneNumber}</p>
      ) : null}
      <p>{state(props.alert)}</p>
    </div>
  );
}
